'use strict';

import {EwSiteApp} from "../../app/ewsiteapp.js";

import {InvitationListSiteCtrl} from "./invitationlistsitectrl.js";
EwSiteApp.controller('InvitationListSiteCtrl', ["$scope", "$http", "$filter", "$timeout", "$locale", "jsDataService", InvitationListSiteCtrl]);

import {InvitationPreviewCtrl} from "./invitationpreviewctrl.js";
EwSiteApp.controller('InvitationPreviewCtrl', ["$scope", "$filter", "$mdDialog", "jsDataService", InvitationPreviewCtrl]);

import {InvitationEditCtrl} from "./invitationeditctrl.js";
EwSiteApp.controller('InvitationEditCtrl', ["$scope", "$filter", "jsDataService", InvitationEditCtrl]);

import {InvitationAppFormCtrl} from "./invitationappform.js";
EwSiteApp.controller('InvitationAppFormCtrl', ["$scope", "$filter", "$mdDialog", "jsDataService", InvitationAppFormCtrl]);

import {InvitationStructureCtrl} from "./invitationstructurectrl.js";
EwSiteApp.controller('InvitationStructureCtrl', ["$scope", "$filter", "$mdDialog", "jsDataService", InvitationStructureCtrl]);

import {InvitationResponsibleCtrl} from "./invitationresponsiblectrl.js";
EwSiteApp.controller('InvitationResponsibleCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", InvitationResponsibleCtrl]);

import {InvitationEvaluationAdmeliCtrl} from "./invitationevaluationadmelictrl.js";
EwSiteApp.controller('InvitationEvaluationAdmeliCtrl', ["$scope", "$filter", "$timeout", "$mdDialog", "jsDataService", "notify", InvitationEvaluationAdmeliCtrl]);

import {InvitationEvaluationAwrcriCtrl} from "./invitationevaluationawrcrictrl.js";
EwSiteApp.controller('InvitationEvaluationAwrcriCtrl', ["$scope", "$filter", "$timeout", "$mdDialog", "jsDataService", "notify", InvitationEvaluationAwrcriCtrl]);
import {InvitationChecklistCtrl} from "./invitationchecklistctrl.js";
EwSiteApp.controller('InvitationChecklistCtrl', ["$scope", "$filter", "$timeout", "$mdDialog", "jsDataService", "notify", InvitationChecklistCtrl]);

import {InvitationPeriodicReportChecklistCtrl} from "./invitationperiodicreportchecklistctrl.js";
EwSiteApp.controller('InvitationPeriodicReportChecklistCtrl', ["$scope", "$filter", "$timeout", "$mdDialog", "jsDataService", "notify", InvitationPeriodicReportChecklistCtrl]);

import {InvitationGaAmendmentChecklistCtrl} from "./invitationgaamendmentchecklistctrl.js";
EwSiteApp.controller('InvitationGaAmendmentChecklistCtrl', ["$scope", "$filter", "$timeout", "$mdDialog", "jsDataService", "notify", InvitationGaAmendmentChecklistCtrl]);

import {InvitationContiniousReportChecklistCtrl} from "./invitationpcontiniousreportchecklistctrl.js";
EwSiteApp.controller('InvitationContiniousReportChecklistCtrl', ["$scope", "$filter", "$timeout", "$mdDialog", "jsDataService", "notify", InvitationContiniousReportChecklistCtrl]);

import {InvitationAttachmentCtrl} from "./invitationattachmentctrl.js";
EwSiteApp.controller('InvitationAttachmentCtrl', ["$scope", "$http", "$mdDialog", "$filter", "notify", "jsDataService", InvitationAttachmentCtrl]);